import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import { axios } from './common';

export const fetchUsers = async () => {
  const response = await axios.get(`${CM_BASE_URL}/users`);

  if (response.status !== 200) {
    throw { message: 'Failed to fetch users' };
  }

  return response.data;
};

export const fetchCurrentUser = async () => {
  const response = await axios.get(`${CM_BASE_URL}/users/me`);

  if (response.status !== 200) {
    throw { message: 'Failed to fetch current user' };
  }

  return response.data;
};
